import { defineMessages } from "react-intl";
export const scope = "components.HisotryAdvancedSearch";

export const messages = defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: "Búsqueda avanzada",
  },
  movementType: {
    id: `${scope}.movementType`,
    defaultMessage: "Tipo de operación",
  },
  receiptPill: {
    id: `${scope}.receiptPill`,
    defaultMessage: "Movimientos entre cuentas",
  },
  couponPill: {
    id: `${scope}.couponPill`,
    defaultMessage: "Boletos",
  },
  agreementPill: {
    id: `${scope}.agreementPill`,
    defaultMessage: "Concertación",
  },
  liquidationPill: {
    id: `${scope}.liquidationPill`,
    defaultMessage: "Liquidación",
  },
  selectCurrency: {
    id: `${scope}.selectCurrency`,
    defaultMessage: "Selecciona activos",
  },
  since: {
    id: `${scope}.since`,
    defaultMessage: "Desde",
  },
  until: {
    id: `${scope}.until`,
    defaultMessage: "Hasta",
  },
  chooseDate: {
    id: `${scope}.chooseDate`,
    defaultMessage: "Elige una fecha",
  },
  search: {
    id: `${scope}.search`,
    defaultMessage: "BUSCAR",
  },
  sendTitle: {
    id: `${scope}.sendTitle`,
    defaultMessage: "Monedas a visualizar",
  },
  byDateType: {
    id: `${scope}.byDateType`,
    defaultMessage: "Por fecha de",
  },
});
